import {searchModel} from "../../../Utilities/Search";
import {isNullOrUndefined} from "../../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../../Utilities/Sort";
import {ORDER_TYPE} from "../orderConstants";

export const orderSearchModel = (userId = "", orderType = `${ORDER_TYPE.All}`, itemName = "", studentName = "", shippingLocationId = "", publisherName = "", isbn = "", format = "", orderStatus = "", districtId = "", patronRole = "", poNumber = "", shelfLocation = "", vendorId = "", accessNumber = "", organization = "") => {
    return Object.assign({}, searchModel(userId.toString(), "itemName", false, "itemName"), {
        itemName,
        orderType,
        studentName,
        shippingLocationId,
        publisherName,
        isbn,
        format,
        orderStatus,
        districtId,
        patronRole,
        poNumber,
        shelfLocation,
        vendorId,
        accessNumber,
        organization,
        ClearOrderSearch: clearOrderSearch,
        ApplySorting: applySorting,
    });
};

function clearOrderSearch(this: Record<string, unknown>) {
    this.orderType = "";
    this.itemName = "";
    this.studentName = "";
    this.shippingLocationId = "";
    this.publisherName = "";
    this.isbn = "";
    this.format = "";
    this.orderStatus = "";
    this.districtId = "";
    this.patronRole = "";
    this.poNumber = "";
    this.shelfLocation = "";
    this.vendorId = "";
    this.accessNumber = "";
    this.organization = "";

    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(orderSearchCriteria: Record<string, any>, orders: Record<string, any>[]) {

    if (isNullOrUndefined(orders) || isArrayNullOrEmpty(orders))
        return orders;

    return orders.sort(dynamicSort(orderSearchCriteria.sortByColumn as string, orderSearchCriteria.sortDescending as boolean));
}

